import { makeStyles, Typography } from "@material-ui/core";
import { Cached as CachedIcon } from "@material-ui/icons";
import { isEmpty } from "lodash";
import React from "react";
import { useIntl } from "react-intl";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(2)
  },
  icon: {
    margin: theme.spacing(1)
  }
}));

const NoData = ({ data, children, message, iconComponent, noRender = false }) => {
  const intl = useIntl();
  const classes = useStyles();

  const Icon = iconComponent || CachedIcon;

  if (!isEmpty(data)) {
    return children;
  }
  if (noRender) {
    return null;
  }
  return (
    <div className={classes.root}>
      <Icon fontSize="large" className={classes.icon} />
      <Typography variant="body2">
        {message ||
          intl.formatMessage({
            id: "Shared.NoData.NoDataHelper",
            defaultMessage: "Please check later for new contents…"
          })}
      </Typography>
    </div>
  );
};

export default NoData;
